// extracted by mini-css-extract-plugin
export default {"section":"section__ptzdj"};